export const chartOfAccountContants = {
  GET_ALL_CHART_OF_ACCOUNT: "GET_ALL_CHART_OF_ACCOUNT",
  GET_ALL_COA_LIST: "GET_ALL_COA_LIST",
};
